<template>
  <div class="boss-main-content-wrap">
    <setting-header
      v-if="isCompanyStaffAccess"
      :breadcrumbs="[{ name: '求人確認' },{ name: '掲載済みの求人・応募フォームタイプ設定', pathName: 'jobPublished' }]"
      title="掲載済みの求人プレビュー"
      class="hide-for-print"
    />

    <div
      data-test="usage-notes-and-print-button"
      class="grid-x hide-for-print"
    >
      <div class="cell auto pega-usage-notes">
        <job-preview-provision-list-link class="pega-accordion-link-header" />
      </div>
      <print-button
        class="cell shrink"
        :is-simple="false"
        @print="print"
      />
    </div>
    <!-- ボタンエリア -->
    <div
      data-test="sp-preview-button"
      class="grid-x margin-bottom-1"
    >
      <div class="cell hide-for-print">
        <sp-preview-button
          :id="Number(offerId)"
          :route-name="spRouteNameForJob"
        />
      </div>
      <div class="cell pega-text-small">
        ※「インタビュー」「フォトクリップ」は掲載時ご利用の場合のみ表示されます。
      </div>
    </div>

    <!-- プレビューエリア -->
    <div v-if="isFinishCreated">
      <!-- 求人情報 -->
      <job-preview :offer="offer" />
      <p class="pega-hide-msg">
        これ以降は、女の転職typeのユーザー画面では表示されません。ただし、提携サイトには表示される場合がございます。<br>
        あらかじめご了承ください。
      </p>
      <!-- マッチング情報 -->
      <job-matching
        :job-category-settings="offer.jobCategorySettings"
        :matching="matching"
      />
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import PrintButton from '@/components/atoms/PrintButton'
import SpPreviewButton from '@/components/atoms/SpPreviewButton'
import JobPreview from '@/components/organisms/JobPreview'
import JobMatching from '@/components/organisms/JobMatching'
import bossSCommon from '@/lib/bossSCommon'
import { mapActions } from 'vuex'
import JobPreviewProvisionListLink from '@/components/atoms/JobPreviewProvisionListLink'

export default {
  components: {
    JobPreviewProvisionListLink,
    SettingHeader,
    PrintButton,
    SpPreviewButton,
    JobPreview,
    JobMatching
  },
  mixins: [bossSCommon],
  data () {
    return {
      isFinishCreated: false, // createdの処理完了を待ってから描画するためのフラグ
      offer: {}, // 求人情報
      matching: {} // マッチング設定
    }
  },
  async created () {
    this.callApis()
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),

    // create:API呼び出し
    callApis () {
      const apis = [
        // 求人情報取得API
        this.$http.secured.get(this.apiPathForFetchJobs),
        // マッチング設定取得API
        this.$http.secured.get(`${this.apiPath}/matching`)
      ]

      // マスタ一括取得
      apis.push(
        this.storeMaster('prIcons'),
        this.storeMaster('skills')
      )

      Promise.all(apis).then(([
        offerResponse, // 求人情報取得API
        matchingResponse // マッチング設定取得API
      ]) => {
        this.$set(this, 'offer', offerResponse.data)
        this.$set(this, 'matching', matchingResponse.data || null)
        this.$set(this, 'isFinishCreated', true)
      })
    },

    // 印刷
    print () {
      window.print()
    }
  }
}
</script>
